import { toast } from 'react-toastify';
import { resizeAndConvertToBase64 } from '../utils/imageHelper';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export function getEffectiveEmail() {
    const active = localStorage.getItem('active_account');
    return active || 'vfast.vn@gmail.com';
}

export function getAllEmails() {
    const runwayAccounts = JSON.parse(
        localStorage.getItem('runway_accounts') || '[]',
    );
    return runwayAccounts.map((acc) => acc.email);
}
//=======================================================Minimax============================================================

export async function getNextHailuoAccount(ownerId) {
    // 1. Lấy danh sách account từ DB
    const aiAccounts = await getAIAccountsByOwner(ownerId);
    const hailuoAccounts = aiAccounts.filter(
        (acc) => acc.provider === 'hailuo' && acc.accountId,
    );

    if (hailuoAccounts.length === 0) {
        throw new Error('Không tìm thấy tài khoản Hailuo để tạo video.');
    }

    // 2. Lấy trạng thái count từ localStorage
    // Key format: "hailuo_counts_[USER_ID]"
    // Mỗi user sẽ có bộ đếm quota riêng cho các shared accounts
    const countsKey = `hailuo_counts_${ownerId}`;

    // storedCounts format: { "accountId1": count1, "accountId2": count2, ... }
    const storedCounts = JSON.parse(localStorage.getItem(countsKey) || '{}');

    // 3. Cleanup localStorage: Xóa các accountId không còn tồn tại trong DB
    const validAccountIds = new Set(hailuoAccounts.map((acc) => acc.accountId));
    Object.keys(storedCounts).forEach((accountId) => {
        if (!validAccountIds.has(accountId)) {
            delete storedCounts[accountId];
        }
    });

    // 4. Tìm account đầu tiên còn quota
    let selectedAcc = null;

    for (const acc of hailuoAccounts) {
        const quota = acc.quota || 1;
        const currentCount = storedCounts[acc.accountId] || 0;

        if (currentCount < quota) {
            selectedAcc = acc;
            break;
        }
    }

    // 5. Nếu tất cả account đều hết quota → Reset tất cả về 0
    if (!selectedAcc) {
        // Reset tất cả về 0
        hailuoAccounts.forEach((acc) => {
            storedCounts[acc.accountId] = 0;
        });

        // Chọn account đầu tiên sau khi reset
        selectedAcc = hailuoAccounts[0];
    }

    // 6. Tăng count cho account được chọn
    const previousCount = storedCounts[selectedAcc.accountId] || 0;
    storedCounts[selectedAcc.accountId] = previousCount + 1;

    // 7. Lưu lại vào localStorage
    localStorage.setItem(countsKey, JSON.stringify(storedCounts));

    return selectedAcc;
}

export async function getNextRunwayAccount(ownerId) {
    const aiAccounts = await getAIAccountsByOwner(ownerId);

    const runwayAccounts = aiAccounts.filter(
        (acc) => acc.provider === 'runway' && acc.email,
    );

    if (runwayAccounts.length === 0) {
        throw new Error('Không tìm thấy tài khoản Runway để tạo video.');
    }

    const key = `runway_round_robin_index_${ownerId}`;
    let index = parseInt(localStorage.getItem(key) || '0', 10);
    const selectedAcc = runwayAccounts[index % runwayAccounts.length];
    localStorage.setItem(key, (index + 1) % runwayAccounts.length);

    return selectedAcc;
}

export async function uploadMinimaxFile(fileObj, ownerId) {
    if (!ownerId || isNaN(ownerId)) {
        throw new Error('❌ ownerId không hợp lệ khi upload Minimax file.');
    }

    const selectedAcc = await getNextHailuoAccount(ownerId);
    const uploadUrl = `${API_URL}/proxy/minimax/upload?account=${selectedAcc.accountId}`;
    const formData = new FormData();
    formData.append('file', fileObj);

    const res = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
    });

    if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Upload Minimax failed (${res.status}): ${errorText}`);
    }

    const data = await res.json();

    const imageBase64 = await resizeAndConvertToBase64(fileObj);

    return {
        fileId: data.fileID,
        accountId: selectedAcc.accountId,
        email: selectedAcc.email || selectedAcc.name || '',
        imageBase64,
        videoId: String(data.fileID).match(/file:(\d+)$/)?.[1],
    };
}

export async function createMinimaxVideo(
    accountId,
    fileId,
    prompt,
    title,
    ownerId,
    email,
    model = 'I2V-01-Director',
    imageBase64 = '',
) {
    const url = `${API_URL}/hailuo/videos`;

    const body = {
        accountId,
        fileId,
        description: prompt?.trim() || 'Không có mô tả',
        title: title || '',
        ownerId,
        email: email || '',
        model,
        thumbnail: imageBase64,
        imageBase64: imageBase64,
        status: 'pending',
    };

    console.log('📤 BODY gửi lên /hailuo/videos:', body);

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    let data;

    try {
        data = await res.json();
    } catch (e) {
        toast.error('❌ Server trả về dữ liệu không hợp lệ.');
        throw new Error('❌ Server trả về dữ liệu không hợp lệ.');
    }

    if (!res.ok) {
        let errorMessage =
            data?.error || data?.message || 'Lỗi tạo video (queue)';
        toast.error(errorMessage);
        throw new Error(errorMessage);
    }

    return data;
}

export async function deleteMinimaxVideo(id) {
    const url = `${API_URL}/hailuo/videos/${id}`;

    const res = await fetch(url, {
        method: 'DELETE',
    });

    const text = await res.text();
    const result = text ? JSON.parse(text) : {};

    if (!res.ok) {
        throw new Error(`Xoá video Hailuo thất bại (status ${res.status})`);
    }

    return result;
}
export async function createMiniMaxAccount(url, token, maxJobs = 5) {
    const apiUrl = `${API_URL}/proxy/minimax/accounts`;

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url: url.trim(), token, maxJobs }),
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'MiniMax API error');
    }

    return await response.json();
}

export function getAllMinimaxAccounts() {
    const raw = localStorage.getItem('minimax_accounts');
    if (!raw) return [];
    try {
        const accounts = JSON.parse(raw);
        return Array.isArray(accounts) ? accounts : [accounts];
    } catch (err) {
        console.error('Lỗi khi parse minimax_accounts', err);
        return [];
    }
}
export async function getAIAccountsByOwner(ownerId) {
    const url = `${API_URL}/accounts/owner/${Number(ownerId)}`;
    const res = await fetch(url);

    if (!res.ok) throw new Error('Không lấy được tài khoản AI');

    const data = await res.json();

    return data;
}

export async function fetchMinimaxVideos(account) {
    let allVideos = [];
    let nextPageToken = null;

    do {
        let url = `${API_URL}/proxy/minimax/videos?account=${account}&limit=300`;
        if (nextPageToken) {
            url += `&pageToken=${nextPageToken}`;
        }

        const res = await fetch(url);

        if (!res.ok) {
            const errorText = await res.text();
            throw new Error(
                `Fetch Minimax videos failed (${res.status}): ${errorText}`,
            );
        }

        const data = await res.json();
        allVideos = allVideos.concat(data.items || data);
        nextPageToken = data.nextPageToken;
    } while (nextPageToken);

    return allVideos;
}

export async function fetchHailuoVideosFromDB(ownerId, options = {}) {
    const {
        searchText,
        title,
        status,
        startDate,
        endDate,
        page = 1,
        limit = 10,
    } = options;

    // Build query parameters
    const params = new URLSearchParams({
        ownerId: ownerId.toString(),
        page: page.toString(),
        limit: limit.toString(),
    });

    // Add optional filters
    if (searchText && searchText.trim()) {
        params.append('searchText', searchText.trim());
    }

    if (title && title.trim()) {
        params.append('title', title.trim());
    }

    if (status && status.trim()) {
        params.append('status', status.trim());
    }

    if (startDate) {
        // Handle both Date objects and strings
        const dateStr =
            startDate instanceof Date ? startDate.toISOString() : startDate;
        params.append('startDate', dateStr);
    }

    if (endDate) {
        const dateStr =
            endDate instanceof Date ? endDate.toISOString() : endDate;
        params.append('endDate', dateStr);
    }

    const url = `${API_URL}/hailuo/videos?${params}`;

    try {
        const res = await fetch(url);

        if (!res.ok) {
            const text = await res.text();
            console.error(
                `❌ Lỗi khi fetch Hailuo videos: ${res.status} - ${text}`,
            );
            throw new Error(`Không lấy được video Hailuo từ DB: ${res.status}`);
        }

        const result = await res.json();
        return result;
    } catch (error) {
        console.error('❌ Error in fetchHailuoVideosFromDB:', error);
        throw error;
    }
}

export async function bulkUpdateDownloadStatus(ids = [], isDownloaded) {
    try {
        const payload = {
            ids,
            isDownloaded,
        };

        const url = `${API_URL}/hailuo/download-status`;

        const res = await axios.patch(url, payload);
        return res.data;
    } catch (error) {
        console.error('❌ Error in bulkUpdateDownloadStatus :', error);
        throw error;
    }
}

//=============================================RUNWAY================================================

export async function uploadRunwayFile(email, fileObj) {
    const uploadUrl = `${API_URL}/proxy/runwayml/upload?name=${encodeURIComponent(
        fileObj.name,
    )}&email=${encodeURIComponent(email)}`;

    const formData = new FormData();
    formData.append('file', fileObj);

    const res = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
    });

    if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Upload Runway failed (${res.status}): ${errorText}`);
    }

    const data = await res.json();
    console.log('✅ Upload Runway result:', data);
    return data.assetId;
}

export async function createRunwayVideo(
    email,
    assetId,
    prompt,
    title,
    ownerId,
    aspectRatio = '16:9',
    seconds = 10,
) {
    const url = `${API_URL}/proxy/runwayml/gen4turbo/create`;

    const body = {
        email,
        firstImage_assetId: assetId,
        text_prompt: prompt?.trim() || 'Không có mô tả',
        aspect_ratio: aspectRatio,
        seconds,
        title: title || '',
        ownerId,
    };

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    const data = await res.json();
    console.log('✅ Create Runway Video:', data);

    if (!res.ok) {
        if (data?.error?.includes('not have enough credits')) {
            throw new Error(
                `Email ${email} không đủ credits để tạo video trên Runway.`,
            );
        }
        throw new Error(
            `Lỗi tạo video Runway cho email ${email}: ${
                data?.error || 'Không rõ lỗi'
            }`,
        );
    }

    return data;
}
export async function fetchRunwayVideosFromDB(ownerId) {
    const url = `${API_URL}/runway/videos/${ownerId}`;
    const res = await fetch(url);

    if (!res.ok) {
        const text = await res.text();
        console.error(`❌ Lỗi khi fetch Runway: ${text}`);
        throw new Error('Không lấy được video Runway từ DB');
    }

    return await res.json();
}

export async function fetchRunwayVideos(email) {
    const url = `${API_URL}/proxy/runwayml/tasks?email=${email}&offset=0&limit=50&t=${Date.now()}`;

    try {
        const res = await fetch(url);

        if (!res.ok) {
            console.error(`Fetch video fail for ${email}`);
            return [];
        }

        const data = await res.json();
        return data;
    } catch (err) {
        console.error('Fetch runway error:', err);
        return [];
    }
}

export async function deleteRunwayVideo(id) {
    const url = `${API_URL}/runway/videos/${id}`;

    const res = await fetch(url, {
        method: 'DELETE',
    });

    const text = await res.text();
    const result = text ? JSON.parse(text) : {};

    console.log('🗑️ Delete Runway video result:', result);

    if (!res.ok) {
        throw new Error(`Xoá video Runway thất bại (status ${res.status})`);
    }

    return result;
}

export async function createRunwayAccount(email, password, maxJobs = 5) {
    const url = `${API_URL}/proxy/runwayml/accounts/${encodeURIComponent(
        email,
    )}`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password, maxJobs }),
    });

    if (!response.ok) {
        let err = {};
        try {
            err = await response.json();
        } catch (_) {
            err = { error: 'Runway API error (no JSON)' };
        }
        throw new Error(err.error || 'Runway API error');
    }

    return await response.json();
}
